module.exports = __webpack_public_path__ + "img/Comorbidity_CKD.bfaecdfc.jpg";